import { createAsyncThunk } from '@reduxjs/toolkit';
import { getWithLang } from '../services/api';
import strings from '../utils/locals/languages';

export const getRecommendedAds = createAsyncThunk(
  'globalData/getRecommendedAds',
  async (_, thunkAPI) => {
    return await getWithLang('/recommended', strings._language);
  }
);

export const getSubCategories = createAsyncThunk(
  'globalData/getSubCategories',
  async (_, thunkAPI) => {
    return await getWithLang('/v1/adds/all-subcategories', strings._language);
  }
);

export const getModels = createAsyncThunk(
  'globalData/getModels',
  async (_, thunkAPI) => {
    return await getWithLang('/v1/adds/all-models', strings._language);
  }
);

export const getSections = createAsyncThunk(
  'globalData/getSections',
  async (_, thunkAPI) => {
    return await getWithLang('v1/adds/sections', strings._language);
  }
);

export const getHomeBanners = createAsyncThunk(
  'globalData/getHomeBanners',
  async (_, thunkAPI) => {
    return await getWithLang('v1/user/get-internal-ads', strings._language);
  }
);
